import React from 'react'
import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'
import {Speaker} from 'Event/Speakers'
import {Draggable} from 'react-beautiful-dnd'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'
import {useEditMode} from 'Event/EditModeProvider'
import Image from 'Event/Speakers/Image'
import SpeakerConfig, {SpeakerConfigurable} from 'Event/Speakers/SpeakerConfig'
import Typography from '@material-ui/core/Typography'
import {useAttendeeVariables} from 'Event'
import Content from 'lib/ui/form/TextEditor/Content'
import Visible from 'lib/ui/layout/Visible'
import {Column} from 'lib/ui/layout'

type SpeakerProps = {
  id: string
  index: number
  speaker: Speaker
}

export default function Card(props: SpeakerProps) {
  const isEditMode = useEditMode()

  if (!isEditMode) {
    return <SpeakerContent {...props} />
  }
  return (
    <Draggable draggableId={String(props.id)} index={props.index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <SpeakerContent {...props} />
        </div>
      )}
    </Draggable>
  )
}

function SpeakerContent(props: SpeakerProps) {
  const {speaker} = props
  const template = useSimpleBlogTemplate()
  const v = useAttendeeVariables()

  const bodySize = (): Column => {
    if (!speaker.image) {
      return 12
    }
    return (12 - template.speakers.imageSize) as Column
  }

  return (
    <Box aria-label="speaker">
      <SpeakerConfigurable>
        <SpeakerConfig speaker={props.speaker} id={props.id} />
        <Grid container spacing={2}>
          <Visible when={Boolean(speaker.image)}>
            <Grid item xs={template.speakers.imageSize}>
              <StyledImage speaker={speaker} />
            </Grid>
          </Visible>
          <GridItem item color={template.textColor} xs={bodySize()}>
            <Box>
              <Typography variant="h5">{v(speaker.name)}</Typography>
            </Box>
            <Content>{v(speaker.text)}</Content>
          </GridItem>
        </Grid>
      </SpeakerConfigurable>
    </Box>
  )
}

const GridItem = styled(Grid)<{color: string}>`
  color: ${(props) => props.color};
`

const Box = styled.div`
  position: relative;
`

const StyledImage = styled(Image)`
  float: left;
  margin: ${(props) =>
    `0 ${props.theme.spacing[4]} ${props.theme.spacing[4]} 0`};
  width: 100%;
  img {
    width: 100%;
  }
`
